import * as React from "react";
import { Typography } from '@mui/material'

const NoPage = () => {
    return <Typography variant='h4' color="text.primary">404 - Error: Page not found</Typography>;
};

export default NoPage;